import { ActivityIndicator } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { ScreenContainer } from "@src/components/ScreenContainer";

interface LoadingScreenProps {
  message: string;
}

export function LoadingScreen({ message }: LoadingScreenProps) {
  const { theme } = useUnistyles();

  return (
    <ScreenContainer edges={["top", "bottom"]}>
      <View flex={1} bg="background" justifyContent="center" alignItems="center" gap="4xl">
        <ActivityIndicator size="large" color={theme.colors.navy[500]} />
        <Text textStyle="md/regular" color="textMuted">
          {message}
        </Text>
      </View>
    </ScreenContainer>
  );
}
